module.exports = __webpack_public_path__ + "img/icon-white-67.cfe88b24.svg";